/* eslint-disable import-x/no-namespace */
import { Control } from '@vlabs/uikit';
import { omit } from 'lodash';

import { filterIsApplied, FilterMenu } from '@vlabs/monokit/shared/ui/filter-menu';

import st from './CardPageFilterMenu.module.sass';
import { useCardPageFiltersTranslation } from './i18n';
import * as sideMenuFilters from './side-menu';
import { useCardPageFilters } from './useCardPageFilters';

function CardPageFilterMenu(): JSX.Element {
  const { t } = useCardPageFiltersTranslation();

  const { filters, resetFilters } = useCardPageFilters();
  const isResetDisabled = Object
    .values(omit(filters, 'pageIndex', 'pageSize'))
    .filter((v) => v !== undefined).length === 0;

  return (
    <FilterMenu
      filters={[
        <sideMenuFilters.DateFilterWithLeftPopover
          badge={filterIsApplied(!!(filters.create_time__lt ?? filters.create_time__gte))}
          key="created_at"
          value={t('date_title')}
        />,
        <sideMenuFilters.FaceIdsFilterWithLeftPopover
          badge={filterIsApplied(!!filters.face_ids)}
          key="face_ids"
          value={t('face_ids_title')}
        />,
        <sideMenuFilters.UserDataFilterWithLeftPopover
          badge={filterIsApplied(!!filters.user_data)}
          key="user_data"
          value={t('user_data_title')}
        />,
      ]}
      footer={(
        <Control.Button
          className={st.ResetButton}
          data-testid="button.reset-card-filters"
          disabled={isResetDisabled}
          kind="negative"
          onClick={() => resetFilters()}
          type="button"
        >
          {t('reset_button')}
        </Control.Button>
      )}
    />
  );
}

export { CardPageFilterMenu };
